import React, { useState, useEffect } from 'react';
import SubscriptionCardContainer from './SubscriptionCardContainer';
import Footer from 'Components/LandingPage/Footer/Footer';
import Styles from './NewUserSubscriptionPlan.module.scss';
import ContactUs from './ContactUs';
import HorizontalTestimonials from '../../Components/Testimonials/HorizontalTestimonials';
import { useSelector } from 'react-redux';

export const NewUserSubscriptionPlan = ({ hideTestimonials = false }) => {
  const { user } = useSelector((state) => state.auth);
  const [currentSubscription, setCurrentSubscription] = useState(null);

  useEffect(() => {
    // Get subscription data from user object
    if (user?.user?.subscriptions?.current_subscription) {
      setCurrentSubscription(user.user.subscriptions.current_subscription);
    }
  }, [user]);

  return (
    <div className="p-4">
      <SubscriptionCardContainer />

      {/* Testimonials Section - Only show when user doesn't have active subscription and hideTestimonials is false */}
      {!currentSubscription?.active && !hideTestimonials && (
        <HorizontalTestimonials
          senjaApiKey="O22b0Cqtm3MwiwC0fqMfOc3vmbJW"
          speed={300}
          limit={1000} // Fetch 1000 testimonials
          minRating={0} // Allow all ratings since Senja data has rating: 0
          enableLengthFiltering={true} // Enable length filtering
          minLength={200} // Minimum 200 characters
          maxLength={300} // Maximum 300 characters
        />
      )}

      {/* <GetAccessCard /> */}
      {/* <FooterSection /> */}
      <ContactUs />
      <div className={Styles.footer_container}>
        <Footer />
      </div>
    </div>
  );
};
